module.exports = __webpack_public_path__ + "img/SIGN_TECATE.d910284c.png";